import styled from 'styled-components';
import {
  grey,
  fontFamilyRoboto,

} from '@components/hoc/Theme/Theme.styled';

export const CheckBoxTitleLabel = styled.label`
  font-size: 16px !important;
  font-family: ${fontFamilyRoboto};
  letter-spacing: 0 !important;
  color: ${grey};
  max-width: 100%;
  display: flex;
  cursor: pointer;
  text-align: justify;
  margin: 2px 8px;
  ${(props) => (props.$iserror ? 'color:#f11a48' : 'color:rgb(49, 49, 49)')};

  @media (max-width: 450px) {
    font-size: 0.8rem !important;
  }
  @media (max-width: 410px) {
    width: 85%;
    text-align: left;
  }
  @media (max-width: 390px) {
    width: 90%;
    text-align: left;
  }
`;

export const CheckBoxAcceptLabel = styled(CheckBoxTitleLabel)`
  font-size: 10px;
`;

export const CheckBoxWrapper = styled.section`
  display: flex;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export const CheckBox = styled.input`
  background-color: transparent;
  border-radius: 2px;
  resize: none;
  display: block;
  height: 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  opacity: 0.8;
  transform: scale(2);
  margin: 10px 20px 0 10px !important;

  &:hover {
    opacity: 0.9;
  }

  &:checked {
    opacity: 1;
  }
`;
